import type { Carer } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useGroupAccess = (): boolean => {
  const groupAccess: boolean | undefined = useSelector(
    (state: { global: { user: Carer } }) => !!state?.global?.user?.homes?.length
  )

  return groupAccess
}

export default useGroupAccess
